/**
 * Returns a new array with the elements in reverse order.
 * Does not modify the original array.
 *
 * @param {T[]} array - The array to reverse.
 * @returns {T[]} A new array with the elements reversed.
 */
export const toReversed = (array) => {
  //TODO: Eliminar cuando babel soporte de forma nativa el toReversed
  //      usar el método nativo.
  return [...array].reverse();
};
